




























































import Component, { mixins } from "vue-class-component";
import MobileMixin from "@/mixins/mobileMixin";
import { Site } from "@/shared/Site";
import _ from "lodash";
import { Societe } from "@/shared/Groupe";

@Component({
  components: {},
})
export default class Configuration extends mixins(MobileMixin) {
  public items: any = [];
  // public societesToUpdate = new Array();
  public msocietes = this.societes;

  public async created() {
    if (this.isMobile()) {
      this.$router.push("/config/messages");
    } else {
      await this.$store.dispatch("config/getSocietes").then((societes: any) => {
        this.compareSite(societes);
      });
      console.log("config/getSocietes done");
      this.$store.dispatch("config/getProfils");
      this.$store.dispatch("config/getGroupes");
      console.log("le client: ", this.client);
      this.items = [
        {
          order: 1,
          title: this.$t("Societes").toString(),
          icon: "mdi-view-dashboard",
          link: "/config/sites",
          notification: true,
          config: true,
          global: true,
        },
        {
          order: 2,
          title: this.$t("Groupes").toString(),
          icon: "mdi-image",
          link: "/config/groupes",
          config: true,
          global: true,
        },
        {
          order: 4,
          title: this.$t("Utilisateurs").toString(),
          icon: "mdi-help-box",
          link: "/config/users",
          config: true,
          global: true,
        },
        {
          order: 3,
          title: this.$t("Profils").toString(),
          icon: "mdi-help-box",
          link: "/config/profils",
          config: true,
          global: true,
        },
        {
          order: 5,
          title: this.$t("Messages").toString(),
          icon: "mdi-email",
          link: "/config/messages",
          config: false,
          global: true,
        },
        {
          order: 6,
          title: this.$t("MiseEnRoute").toString(),
          icon: "mdi-email",
          link: "/config/miseenroute",
          config: true,
          global: false,
        },
        {
          order: 7,
          title: "Adoria",
          icon: "mdi-email",
          link: "/config/adoria",
          config: false,
          global: false,
          identifier: "export",
        },
        {
          order: 7,
          title: "Easilys",
          icon: "mdi-email",
          link: "/config/easilys",
          config: false,
          global: false,
          identifier: "export",
        },
        {
          order: 8,
          title: "Ecash",
          icon: "mdi-email",
          link: "/config/ecash",
          config: true,
          global: true,
          client: "HIPPO",
        },
        {
          order: 9,
          title: this.$t("BDD").toString(),
          icon: "mdi-database",
          link: "/config/bdd",
          config: true,
          global: false,
        },
        {
          order: 10,
          title: this.$t("ComptageRule").toString(),
          icon: "mdi-format-list-bulleted-type",
          link: "/config/rules",
          config: true,
          global: false,
        },
        {
          order: 11,
          title: this.$t("Recurrences").toString(),
          icon: "",
          link: "/config/recurrences",
          config: false,
          global: false,
        },
        {
          order: 12,
          title: "Consolidations",
          icon: "",
          link: "/config/consolidations",
          config: false,
          global: false,
        },
      ];
      this.items = this.items.sort((p1: any, p2: any) => {
        return p1.order - p2.order;
      });
    }
  }

  // public filteredItem() {
  //   // console.log(this.client);
  //   let itemsToShow = this.items;
  //   if (this.global && this.items) {
  //     // console.log(this.items);
  //     itemsToShow = this.items.filter((item: any) => item.global);
  //   }
  //   if (this.me && this.me.droits.indexOf("CONFIGURATION") === -1) {
  //     itemsToShow = itemsToShow.filter((item: any) => !item.config);
  //   }
  //   itemsToShow = itemsToShow.filter((item: any) => {
  //     if (item.client !== undefined) {
  //       return item.client.includes(this.client);
  //     } else {
  //       return item;
  //     }
  //   });
  //   return itemsToShow;
  // }
  public filteredItem() {
    let itemsToShow = this.items;

    if (this.global) {
      itemsToShow = itemsToShow.filter((item: any) => item.global);
    }

    if (this.me && !this.me.droits.includes("CONFIGURATION")) {
      itemsToShow = itemsToShow.filter((item: any) => !item.config);
    }

    itemsToShow = itemsToShow.filter((item: any) => {
      if (item.identifier === "export") {
        if (["HAN", "PDF"].includes(this.client)) {
          return item.title === "Easilys";
        } else {
          return item.title === "Adoria";
        }
      }
      if (item.client !== undefined) {
        return item.client.includes(this.client);
      }
      return true;
    });

    return itemsToShow.sort(
      (a: { order: number }, b: { order: number }) => a.order - b.order
    );
  }

  /**
   * methode permettant de comparer les société existantes aux sites pour calculer les société manquantes
   */
  public compareSite(societes: any) {
    let societesNames: any;
    if (this.client !== "TOTAL") {
      societesNames = societes.map((societe: any) => {
        return societe.restaurantId;
      });
    } else {
      societesNames = societes.map((societe: any) => {
        return societe.codeImplant;
      });
    }

    societesNames = _.orderBy(societesNames);
    let aCreer: any;
    if (this.client !== "TOTAL") {
      aCreer = this.sites.filter((site: Site) => {
        return societesNames.indexOf(site.restaurantId) === -1;
      });
    } else {
      aCreer = this.sites.filter((site: Site) => {
        return societesNames.indexOf(site.extras.code_implant) === -1;
      });
    }
    this.$store.dispatch("config/setSocieteACreer", aCreer);

    /** A supprimer, utilisé pour gerer la creation du restaurantid sur les sociétés  */
    /*this.societesToUpdate = new Array();
    this.societesToUpdate = societes.filter((societe: any) => {
      const site = this.sites.find(
        (msite: Site) => msite.libelle === societe.raisonSociale && msite.extras.code_implant === societe.codeImplant
      );
      if (site) {
        societe.restaurantId = site.restaurantId;
        return societe;
      }
    });
  }

  public async update() {
    console.log("update");
    console.log(this.societesToUpdate);
    for (const soc of this.societesToUpdate) {
      await this.updateSocietesCorrect(soc);
    }*/
  }
  private async updateSocietesCorrect(societe: any) {
    // console.log(societe);
    return await this.$store.dispatch("config/updateOneSociete", societe).then(
      (response: any) => console.log(response),
      (error: any) => console.log(error)
    );
  }

  // computed
  get sites(): Site[] {
    return this.$store.getters["login/sites"];
  }
  get societes(): Societe[] {
    return this.$store.getters["config/societes"];
  }
  get societesACreer(): Site[] {
    return this.$store.getters["config/societesACreer"];
  }

  get global(): boolean {
    return this.$store.getters["getGlobal"];
  }

  get me(): any {
    return this.$store.getters["login/user"];
  }

  get client(): string {
    return this.$store.getters["getClient"];
  }
}
